import React from 'react'
import PropTypes from 'prop-types'
import 'styles/d3/button.scss'
import { Loader } from 'components/UIElements'

const customProps = [
  'square',
  'secondary',
  'active',
  'selected',
  'grey',
  'style',
  'inline',
  'link',
  'noStyling',
  'no-padding',
  'no-margin',
  'iconAfter',
  'loading',
]

const Button = React.forwardRef((props, ref) => {
  const _props = Object.assign({}, props)
  delete _props.loading
  customProps.forEach(prop => {
    if (_props[prop]) delete _props[prop]
  })
  const {
    className,
    loading,
    icon,
    content,
    children,
    iconAfter,
    type = 'submit',
  } = props
  let btnClassName = 'custom-button'
  btnClassName = `${btnClassName} ${customProps
    .filter(name => props[name])
    .join(' ')}`
  btnClassName += className ? ` ${className}` : ''
  return (
    <button type={type} {..._props} className={btnClassName} ref={ref}>
      {loading && <Loader inContainer size={15} />}
      {!loading && !iconAfter && icon && <i className={icon} />}
      {content || children}
      {iconAfter && icon && <i className={icon} />}
    </button>
  )
})

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  className: PropTypes.string,
  content: PropTypes.node,
  icon: PropTypes.string,
  iconAfter: PropTypes.bool,
  loading: PropTypes.bool,
  type: PropTypes.string,
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button.js